const Loader = () => {
    return(
        <div className="loader-main">
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Loader